import Page from "src/components/Report/Page";
import MiniChart from "./components/MiniChart";
import { useLocation } from "react-router-dom";

export default function Page21() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let translate = {
        0: "خیلی کم",
        1: "کم",
        2: "متوسط",
        3: "زیاد",
        4: "خیلی زیاد",
    }
    let panjVizhegiBarezRaftari;
    if (JSON.parse(localStorage?.data)?.[jobId]?.panjVizhegiBarezRaftari) {
        panjVizhegiBarezRaftari = JSON.parse(localStorage?.data)?.[jobId]?.panjVizhegiBarezRaftari
    } else {
        panjVizhegiBarezRaftari = []
    }

    let div = Object.keys(panjVizhegiBarezRaftari).map(function (key, index) {
        return (<div className="flex flex-col flex-1 items-center gap-3">
            <span className="text-xs">{translate[panjVizhegiBarezRaftari[key].value]}</span>
            <div className={`w-[50px] ${panjVizhegiBarezRaftari[key].value == 0 ? "h-[60px]" : panjVizhegiBarezRaftari[key].value == 1 ? "h-[100px]" : panjVizhegiBarezRaftari[key].value == 2 ? "h-[140px]" : panjVizhegiBarezRaftari[key].value == 3 ? "h-[180px]" : panjVizhegiBarezRaftari[key].value == 4 ? "h-[220px]" : null} bg-[#5b5cff] rounded-md`}></div>
            <span className="text-xs">{key}</span>
        </div>)
    })
    // console.log(panjVizhegiBarezRaftari);
    return (
        <Page pageNumber={21}>
            <div className="font-bold text-lg">
                پنج ویژگی بارز رفتاری
            </div>
            <div className="px-28 relative mt-10">
                <div className="flex justify-between items-end ">
                    {div}
                </div>
                <div className="absolute w-full h-[3px] bg-gray-300 bottom-[28px] m-auto left-0"></div>
            </div>
            <div className="flex flex-col mt-10">

                {
                    Object.keys(panjVizhegiBarezRaftari).sort(function (a, b) { return panjVizhegiBarezRaftari[b].value - panjVizhegiBarezRaftari[a].value }).map((key, index) => {
                        if (panjVizhegiBarezRaftari[key].value >= 0) {
                            return (
                                <div className="flex items-center gap-3 odd-color">
                                    <MiniChart value={panjVizhegiBarezRaftari[key].value} height={30} />
                                    <div className="max-w-[220px] min-w-[220px] w-[220px] border-x-2 px-2 text-sm text-center">{key}</div>
                                    <div className="text-[13px]">{panjVizhegiBarezRaftari[key].desc}</div>
                                </div>
                            )
                        }
                    })
                }
            </div>
        </Page>
    )
}